import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CollectionDocument, CollectionsState } from '@/shared/types/collections';

const defaultState: CollectionsState = {
  isPublishModalOpen: false,
  isDeleteDatasourceModalOpen: false,
  isDeleteCollectionModalOpen: false,
  isDeleteDocumentModalOpen: false,
  isDeleteDocumentsModalOpen: false,
  selectedDocumentsForDeletion: [],
  deleteDatasourceTargetId: null,
  deleteDocumentTarget: null,
} as const;

const slice = createSlice({
  name: 'collections',
  initialState: defaultState,
  reducers: {
    setIsPublishModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isPublishModalOpen = action.payload;
    },
    openPublishModal: (state) => {
      state.isPublishModalOpen = true;
    },
    closePublishModal: (state) => {
      state.isPublishModalOpen = false;
    },
    openDeleteDatasourceModal: (state, action: PayloadAction<string>) => {
      state.isDeleteDatasourceModalOpen = true;
      state.deleteDatasourceTargetId = action.payload;
    },
    closeDeleteDatasourceModal: (state) => {
      state.isDeleteDatasourceModalOpen = false;
      state.deleteDatasourceTargetId = null;
    },
    setIsDeleteCollectionModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isDeleteCollectionModalOpen = action.payload;
    },
    openDeleteCollectionModal: (state) => {
      state.isDeleteCollectionModalOpen = true;
    },
    closeDeleteCollectionModal: (state) => {
      state.isDeleteCollectionModalOpen = false;
    },
    openDeleteDocumentModal: (
      state,
      action: PayloadAction<{ datasource_id: string; document_id: string }>
    ) => {
      state.isDeleteDocumentModalOpen = true;
      state.deleteDocumentTarget = action.payload;
    },
    closeDeleteDocumentModal: (state) => {
      state.isDeleteDocumentModalOpen = false;
      state.deleteDocumentTarget = null;
    },
    setIsDeleteDocumentsModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isDeleteDocumentsModalOpen = action.payload;
    },
    openDeleteDocumentsModal: (state) => {
      state.isDeleteDocumentsModalOpen = true;
    },
    closeDeleteDocumentsModal: (state) => {
      state.isDeleteDocumentsModalOpen = false;
      state.selectedDocumentsForDeletion = [];
    },
    setSelectedDocumentsForDeletion: (state, action: PayloadAction<CollectionDocument[]>) => {
      state.selectedDocumentsForDeletion = action.payload;
    },
  },
});

export const {
  setIsPublishModalOpen,
  openPublishModal,
  closePublishModal,
  openDeleteDatasourceModal,
  closeDeleteDatasourceModal,
  setIsDeleteCollectionModalOpen,
  openDeleteCollectionModal,
  closeDeleteCollectionModal,
  openDeleteDocumentModal,
  closeDeleteDocumentModal,
  setIsDeleteDocumentsModalOpen,
  openDeleteDocumentsModal,
  closeDeleteDocumentsModal,
  setSelectedDocumentsForDeletion,
} = slice.actions;

export default slice.reducer;
